/* VitaGreen PDP-Neubau v4 (03.10.2026): Verhalten der Sektionen und Blöcke vgp-*.
   Grundsatz: keine zweite Kauflogik. Menge, Größe und Warenkorb laufen über die echte
   Horizon-Kaufbox (Mengenfeld, Größen-Knöpfe, Warenkorb-Knopf). Dieses Modul zeigt nur an,
   rechnet Preise für die Anzeige und reicht Klicks an die Kaufbox weiter. */

/* Geldbeträge im Format des Shops (shop.money_format, z. B. „€{{amount_with_comma_separator}}“),
   damit Kacheln, Knopf und Leiste genauso aussehen wie der Liquid-Preis daneben. */
function makeMoney(format) {
  const f = format || '{{amount_with_comma_separator}} €';
  const parts = (c, dec, th, ds) => {
    const [a, b] = (c / 100).toFixed(dec).split('.');
    const int = a.replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return dec ? `${int}${ds}${b}` : int;
  };
  return (cents) => {
    const c = Math.round(cents);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_with_comma_separator') return parts(c, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return parts(c, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return parts(c, 2, "'", '.');
      if (k === 'amount_no_decimals') return parts(c, 0, ',', '.');
      return parts(c, 2, ',', '.');
    });
  };
}
const moneyEl = document.querySelector('[data-vgp-money]');
const money = makeMoney(moneyEl && moneyEl.dataset.vgpMoney);
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

const kb = {
  form: () => document.querySelector('.product-information product-form-component'),
  button() {
    const f = this.form();
    return f && (f.querySelector('button[name="add"]') || f.querySelector('.add-to-cart-button'));
  },
  qtyInput: () => document.querySelector('.product-information quantity-selector-component input[name="quantity"]'),
  sizeInput: (id) => document.querySelector(`.product-information variant-picker input[data-variant-id="${id}"]`),
  checkedId() {
    const c = document.querySelector('.product-information variant-picker input:checked[data-variant-id]');
    return c ? c.dataset.variantId : null;
  },
  media() {
    const c = document.querySelector('.product-information add-to-cart-component[data-product-variant-media]');
    return c ? c.dataset.productVariantMedia : '';
  },
};

/* Korrektur 2 (A11): Kaufen aus Sticky-Leiste oder Kaufzeile. Das freigestellte Packungsbild fliegt
   vom geklickten Knopf in den Warenkorb, auf derselben Bahn wie beim Kaufbox-Knopf (fly-to-cart--main).
   Der Kaufbox-Knopf wird dabei als „Puppe“ geklickt (Horizon-Mechanik der Sticky-Leiste), damit nicht
   zusätzlich ein Bild vom unsichtbaren Kaufbox-Knopf startet. Gekauft wird weiter nur über die Kaufbox. */
function flyFrom(source) {
  const cart = document.querySelector('.header-actions__cart-icon');
  const img = kb.media();
  if (!cart || !img || !source || reduced.matches || !customElements.get('fly-to-cart')) return;
  const fly = document.createElement('fly-to-cart');
  fly.classList.add('fly-to-cart--main', 'vgp-fly');
  fly.style.setProperty('background-image', `url(${img.replace(/width=\d+/, 'width=200')})`);
  fly.style.setProperty('--start-opacity', '0');
  fly.source = source;
  fly.destination = cart;
  document.body.appendChild(fly);
}
function buyFrom(source) {
  const b = kb.button();
  if (b && !b.disabled) {
    flyFrom(source);
    b.dataset.puppet = 'true';
    b.click();
    setTimeout(() => { delete b.dataset.puppet; }, 0);
  } else if (kb.form()) {
    kb.form().scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
  }
}

/* ---------------------------------------------------------------- Mengenstaffel */
function parseTiers(spec) {
  return String(spec || '')
    .split(',')
    .map((p) => p.split(':').map((n) => parseFloat(n)))
    .filter(([q, p]) => q > 1 && p >= 0)
    .map(([q, p]) => ({ q, p }))
    .sort((a, b) => a.q - b.q);
}
const pctFor = (tiers, qty) => tiers.reduce((p, t) => (qty >= t.q ? t.p : p), 0);
const eachFor = (price, pct) => Math.round((price * (100 - pct)) / 100);

function initStaffel(root) {
  const dataEl = root.querySelector('[data-vgp-staffel-data]');
  if (!dataEl) return;
  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const byId = new Map(data.variants.map((v) => [String(v.id), v]));
  const live = root.dataset.live === 'true';
  const topChip = root.dataset.topChip !== 'false';
  const unit = root.dataset.unit || 'Packung';
  const units = root.dataset.units || 'Packungen';
  const chipsEl = root.querySelector('[data-chips]');
  const input = root.querySelector('[data-step-input]');
  const liveLine = root.querySelector('[data-live-line]');
  const saveEl = root.querySelector('[data-save]');
  const tipEl = root.querySelector('[data-size-tip]');
  const topEl = root.querySelector('.vgp-qty__top');
  const unitEl = root.querySelector('[data-unit-line]');
  // Korrektur 6: Kapselzahl + € je 100 Kapseln über der Mengenauswahl folgt der gewählten Größe
  const setUnit = (v) => { if (!unitEl) return; const t = (v && v.u100) || ''; unitEl.textContent = t; unitEl.hidden = !t; };
  const maxQty = data.maxQty || 20;
  let variant = byId.get(String(kb.checkedId() || data.current)) || data.variants[0];
  let qty = 1;
  let atcBase = null;

  function chipList(v) {
    const tiers = parseTiers(v.tiers);
    const list = [{ q: 1, p: 0 }, ...tiers];
    const shown = !topChip && tiers.length > 1 ? list.slice(0, -1) : list;
    return shown.map((t, i) => {
      const next = list[i + 1];
      const max = next ? next.q - 1 : Infinity;
      return { min: t.q, max: !topChip && i === shown.length - 1 && next ? next.q - 1 : max, pct: t.p };
    });
  }

  function yearQty(v) {
    if (root.dataset.year !== 'true' || !(v.days > 0)) return 0;
    for (let q = 1; q <= 5; q++) {
      const d = v.days * q;
      if (d >= 360 && d <= 729) return q;
    }
    return 0;
  }

  function renderChips() {
    const chips = chipList(variant);
    const yq = yearQty(variant);
    chipsEl.innerHTML = '';
    chips.forEach((c) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'vgp-chip';
      b.setAttribute('role', 'radio');
      b.dataset.qty = String(c.min);
      b.dataset.max = c.max === Infinity ? '' : String(c.max);
      const label = c.min === 1 ? '1' : c.max === Infinity ? `ab ${c.min}` : c.max === c.min ? String(c.min) : `${c.min}–${c.max}`;
      const each = eachFor(variant.price, c.pct);
      b.innerHTML =
        `<span class="vgp-chip__q">${label}</span>` +
        (c.pct ? `<span class="vgp-chip__u vgp-chip__u--pct">−${c.pct} %</span><span class="vgp-chip__p">je ${money(each)}</span>`
               : `<span class="vgp-chip__u">${unit}</span><span class="vgp-chip__p">${money(variant.price)}</span>`);
      b.setAttribute('aria-label', c.min === 1 ? `1 ${unit}, ${money(variant.price)}` : `${label} ${units}, minus ${c.pct} Prozent, je ${money(each)}`);
      if (yq && yq >= c.min && yq <= c.max) {
        const badge = document.createElement('span');
        badge.className = 'vgp-chip__badge';
        badge.textContent = 'Jahresvorrat';
        b.appendChild(badge);
        b.setAttribute('aria-label', b.getAttribute('aria-label') + ', reicht ein Jahr');
      }
      b.addEventListener('click', () => setQty(c.min, true));
      chipsEl.appendChild(b);
    });
    if (topEl) {
      const tiers = parseTiers(variant.tiers);
      const top = tiers[tiers.length - 1];
      topEl.hidden = topChip || tiers.length < 2;
      if (top) topEl.textContent = `Ab ${top.q} ${units}: −${top.p} % je ${unit}.`;
    }
  }

  function markChips() {
    const items = [...chipsEl.querySelectorAll('.vgp-chip')];
    let any = false;
    items.forEach((b) => {
      const min = +b.dataset.qty;
      const max = b.dataset.max ? +b.dataset.max : Infinity;
      const on = qty >= min && qty <= max;
      any = any || on;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    if (!any && items[0]) items[0].tabIndex = 0;
  }

  function setQty(q, fromChip) {
    qty = Math.max(1, Math.min(maxQty, Math.round(+q || 1)));
    input.value = String(qty);
    const hq = kb.qtyInput();
    if (hq && hq.value !== String(qty)) {
      hq.value = String(qty);
      hq.dispatchEvent(new Event('input', { bubbles: true }));
      hq.dispatchEvent(new Event('change', { bubbles: true }));
    }
    update();
    if (fromChip) {
      const on = chipsEl.querySelector('[aria-checked="true"]');
      if (on) on.focus({ preventScroll: true });
    }
  }

  /* Hinweis auf die günstigere größere Packung: Wer mindestens so viel kauft, wie eine größere
     Packung enthält, und dort pro Tag weniger zahlt, bekommt es gesagt (kein Upsell, eine Ersparnis). */
  function otherSizeTip(each) {
    if (root.dataset.sizeHint !== 'true' || qty < 2 || !(variant.days > 0)) return '';
    const cur = each / variant.days;
    const reach = variant.days * qty;
    const better = data.variants
      .filter((v) => !v.hidden && v.available && String(v.id) !== String(variant.id) && v.days > variant.days && reach >= v.days * 0.95)
      .map((v) => ({ v, ppd: v.price / v.days }))
      .filter((x) => x.ppd < cur * 0.98)
      .sort((a, b) => a.ppd - b.ppd)[0];
    if (!better) return '';
    return `Für ${qty} × ${variant.label} lohnt sich die ${better.v.label}: ≈ ${money(better.ppd)} statt ≈ ${money(cur)} pro Tag.`;
  }

  function update() {
    const tiers = parseTiers(variant.tiers);
    const pct = pctFor(tiers, qty);
    const each = eachFor(variant.price, pct);
    const total = each * qty;
    const full = variant.price * qty;
    const days = variant.days > 0 ? Math.floor(variant.days * qty) : 0;
    markChips();
    liveLine.textContent = `${qty} × ${variant.label}${days ? ` · reicht ca. ${days} Tage` : ''}`;
    /* Korrektur 2 (A1): Die Ersparnis steht groß da, sobald eine Stufe greift. Solange der Rabatt im
       Shop nicht angelegt ist, bleibt der Vorschau-Hinweis darunter sichtbar (Seite verspricht nichts,
       was der Warenkorb nicht hält); der Knopf nennt dann keinen rabattierten Betrag. */
    if (pct > 0) {
      saveEl.hidden = false;
      saveEl.innerHTML = `<strong>Du sparst ${money(full - total)}</strong><span>(−${pct} %) · ${qty} × je ${money(each)} = ${money(total)} statt ${money(full)}</span>`;
    } else {
      saveEl.hidden = true;
      saveEl.textContent = '';
    }
    paintDayPrice(each, days);
    const tip = otherSizeTip(each);
    tipEl.hidden = !tip;
    tipEl.textContent = tip;

    const btn = kb.button();
    const span = btn && btn.querySelector('.add-to-cart-text__content > span');
    if (span) {
      if (atcBase === null) atcBase = span.textContent.trim();
      span.textContent = live && !btn.disabled ? `${atcBase} · ${money(total)}` : atcBase;
    }
    const chips = chipList(variant).map((c) => ({ ...c, each: eachFor(variant.price, c.pct) }));
    document.dispatchEvent(
      new CustomEvent('vgp:selection', {
        detail: { variantId: String(variant.id), label: variant.label, qty, pct, each, total, full, save: full - total, days, ppd: variant.days > 0 ? each / variant.days : 0, live, price: variant.price, chips, unit, units },
      })
    );
  }

  /* Tagespreis-Zeile der Kaufbox (snippets/vg-preis-pro-tag, Block vg_price_day) rechnet mit Menge und
     Stufe. Ausgangstext bleibt bei 1 Packung gleich: „≈ €0,96 pro Tag · 31 Tagesrationen je Packung“. */
  let dayBase = null;
  function paintDayPrice(each, days) {
    const el = document.querySelector('.product-information [data-vg-preis-pro-tag]');
    if (!el || !(variant.days > 0)) return;
    if (dayBase === null || !el.classList.contains('is-vgp-live')) dayBase = el.textContent;
    el.classList.add('is-vgp-live');
    const ppd = each / variant.days;
    el.innerHTML = qty === 1
      ? `≈ ${money(ppd)} pro Tag · ${Math.floor(variant.days)} Tagesrationen je Packung`
      : `≈ ${money(ppd)} pro Tag <span class="vgp-ppd-note">· ${qty} Packungen reichen ca. ${days} Tage</span>`;
  }
  window.vgpStaffel = { setQty: (q) => setQty(q, false), refresh: () => update() };

  chipsEl.addEventListener('keydown', (e) => {
    const items = [...chipsEl.querySelectorAll('.vgp-chip')];
    const i = items.indexOf(document.activeElement);
    if (i < 0) return;
    let j = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % items.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + items.length) % items.length;
    if (j === null) return;
    e.preventDefault();
    setQty(items[j].dataset.qty, true);
  });
  root.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => setQty(qty + +b.dataset.step)));
  input.addEventListener('change', () => setQty(input.value));
  input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); setQty(input.value); } });

  document.addEventListener('variant:update', (e) => {
    const id = e.detail && e.detail.resource && String(e.detail.resource.id);
    if (!id || !byId.has(id)) return;
    variant = byId.get(id);
    setUnit(variant);
    renderChips();
    // Horizon setzt das Mengenfeld beim Größenwechsel nicht zurück; Anzeige folgt der Menge.
    setQty(qty);
    decorateSizes(data);
    // Horizon zeichnet Preis und Tagespreis nach dem Ereignis neu: danach noch einmal rechnen.
    setTimeout(update, 350);
    setTimeout(update, 1200);
  });
  document.addEventListener('cart:update', () => {
    const hq = kb.qtyInput();
    if (hq && +hq.value !== qty) setQty(hq.value);
  });

  setUnit(variant);
  renderChips();
  setQty(kb.qtyInput() ? kb.qtyInput().value : 1);
  decorateSizes(data);
  observeSizes(data);
}

/* Reichweite unter jedem Größen-Knopf („≈ 125 Tage“), Heinrichs Zusatzregel */
function decorateSizes(data) {
  document.querySelectorAll('.product-information variant-picker input[data-variant-id]').forEach((inp) => {
    const v = data.variants.find((x) => String(x.id) === inp.dataset.variantId);
    const label = inp.closest('label') || (inp.id && document.querySelector(`label[for="${inp.id}"]`)) || inp.parentElement;
    if (!v || !label || !(v.days > 0) || label.querySelector('.vgp-reach')) return;
    const s = document.createElement('span');
    s.className = 'vgp-reach';
    s.textContent = `≈ ${Math.floor(v.days)} Tage`;
    label.appendChild(s);
  });
}
function observeSizes(data) {
  const picker = document.querySelector('.product-information variant-picker');
  if (!picker) return;
  new MutationObserver(() => decorateSizes(data)).observe(picker, { childList: true, subtree: true });
}

/* ---------------------------------------------------------------- Sticky-Leiste */
function initSticky(bar) {
  const root = document.documentElement;
  const sel = bar.querySelector('[data-sel]');
  const price = bar.querySelector('[data-out-price]');
  const ppd = bar.querySelector('[data-out-ppd]');
  const btn = bar.querySelector('[data-buy]');
  const img = bar.querySelector('.vgp-sticky__img');
  let raf = 0;
  let on = false;

  const anchor = () => document.querySelector('.product-information .vgp-guar') || kb.button();
  const buyrow = () => document.querySelector('[data-vgp-buyrow]');

  function apply(next) {
    if (next === on) return;
    on = next;
    if (on) { bar.setAttribute('data-on', ''); bar.removeAttribute('inert'); }
    else { bar.removeAttribute('data-on'); bar.setAttribute('inert', ''); }
    root.classList.toggle('vgp-sticky-on', on);
    root.classList.toggle('vg-sbb-on', on);
    root.style.setProperty('--vg-sbb-h', on ? `${bar.offsetHeight}px` : '0px');
  }
  function measure() {
    raf = 0;
    const a = anchor();
    if (!a) return;
    const past = a.getBoundingClientRect().bottom < 0;
    const br = buyrow();
    let rowVisible = false;
    if (br) { const r = br.getBoundingClientRect(); rowVisible = r.top < window.innerHeight && r.bottom > 0; }
    apply(past && !rowVisible);
  }
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(measure); };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  measure();

  const sizes = [...bar.querySelectorAll('.vgp-ssize')];
  function markSize(id) { sizes.forEach((b) => b.setAttribute('aria-checked', b.dataset.variant === String(id) ? 'true' : 'false')); }
  sizes.forEach((b) => b.addEventListener('click', () => {
    markSize(b.dataset.variant);
    const inp = kb.sizeInput(b.dataset.variant);
    if (inp && !inp.checked) inp.click();
  }));
  document.addEventListener('vgp:selection', (e) => {
    const d = e.detail;
    if (sel) sel.textContent = `${d.qty > 1 ? `${d.qty} × ` : ''}${d.label}${d.days ? ` · ≈ ${d.days} Tage` : ''}`;
    if (price) price.textContent = money(d.live ? d.total : d.price * d.qty);
    if (ppd) ppd.textContent = d.ppd ? `${d.qty > 1 ? `${d.qty} ${d.units} · ` : ''}≈ ${money(d.ppd)} / Tag` : '';
    markSize(d.variantId);
  });
  document.addEventListener('variant:update', (e) => {
    const r = e.detail && e.detail.resource;
    if (img && r && r.featured_media && r.featured_media.preview_image) img.src = `${r.featured_media.preview_image.src}&width=120`;
    if (btn && r) btn.disabled = !r.available;
    if (r && r.id) markSize(r.id);
  });
  btn && btn.addEventListener('click', () => buyFrom(btn));
}

/* ---------------------------------------------------------------- Abschluss-Kaufzeile */
function initBuyrow(row) {
  const price = row.querySelector('[data-out-price]');
  const ppd = row.querySelector('[data-out-ppd]');
  const sizes = [...row.querySelectorAll('[data-variant]')];
  function show(id) {
    sizes.forEach((b) => {
      const onB = b.dataset.variant === String(id);
      b.setAttribute('aria-checked', onB ? 'true' : 'false');
      if (onB) { price.textContent = b.dataset.price; ppd.textContent = b.dataset.ppd || ''; }
    });
  }
  sizes.forEach((b) => b.addEventListener('click', () => {
    show(b.dataset.variant);
    const inp = kb.sizeInput(b.dataset.variant);
    if (inp && !inp.checked) inp.click();
  }));
  document.addEventListener('variant:update', (e) => {
    const r = e.detail && e.detail.resource;
    if (r && r.id) show(r.id);
  });
  const buyBtn = row.querySelector('[data-buy]');
  buyBtn.addEventListener('click', () => buyFrom(buyBtn));

  /* Korrektur 2 (A17): Mengenstaffel auch hier. Kacheln aus denselben Daten wie die Kaufbox, ein Klick
     setzt die Menge in der Kaufbox; Preis, Tagespreis und Ersparnis rechnen live mit. */
  const qtyWrap = row.querySelector('[data-vgp-buyrow-qty]');
  const chipsEl = row.querySelector('[data-bchips]');
  const saveEl = row.querySelector('[data-out-save]');
  let sig = '';
  document.addEventListener('vgp:selection', (e) => {
    const d = e.detail;
    show(d.variantId);
    price.textContent = money(d.qty > 1 || d.pct ? d.total : d.price);
    ppd.textContent = d.ppd ? `${d.qty > 1 ? `${d.qty} × ${d.label} · ` : ''}≈ ${money(d.ppd)} / Tag` : '';
    if (saveEl) {
      saveEl.hidden = !(d.pct > 0);
      saveEl.textContent = d.pct > 0 ? `Du sparst ${money(d.save)} (−${d.pct} %)` : '';
    }
    if (!qtyWrap || !chipsEl || !window.vgpStaffel) return;
    qtyWrap.hidden = false;
    const next = JSON.stringify(d.chips.map((c) => [c.min, c.max, c.pct, c.each]));
    if (next !== sig) {
      sig = next;
      chipsEl.innerHTML = '';
      d.chips.forEach((c) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'vgp-bchip';
        b.setAttribute('role', 'radio');
        b.dataset.min = String(c.min);
        b.dataset.max = c.max === Infinity || c.max === null ? '' : String(c.max);
        const label = c.min === 1 ? '1' : !b.dataset.max ? `ab ${c.min}` : c.max === c.min ? String(c.min) : `${c.min}–${c.max}`;
        b.innerHTML = `${label}<small>${c.pct ? `−${c.pct} %` : d.unit}</small>`;
        b.setAttribute('aria-label', c.min === 1 ? `1 ${d.unit}` : `${label} ${d.units}, minus ${c.pct} Prozent, je ${money(c.each)}`);
        b.addEventListener('click', () => window.vgpStaffel.setQty(c.min));
        chipsEl.appendChild(b);
      });
    }
    chipsEl.querySelectorAll('.vgp-bchip').forEach((b) => {
      const max = b.dataset.max ? +b.dataset.max : Infinity;
      const on = d.qty >= +b.dataset.min && d.qty <= max;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
  });
  chipsEl && chipsEl.addEventListener('keydown', (e) => {
    const items = [...chipsEl.querySelectorAll('.vgp-bchip')];
    const i = items.indexOf(document.activeElement);
    if (i < 0) return;
    let j = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % items.length;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + items.length) % items.length;
    if (j === null) return;
    e.preventDefault();
    items[j].click();
    requestAnimationFrame(() => { const on = chipsEl.querySelector('[aria-checked="true"]'); if (on) on.focus(); });
  });
  const c = kb.checkedId();
  if (c) show(c);
  if (window.vgpStaffel) window.vgpStaffel.refresh();
}

/* ---------------------------------------------------------------- Kundenstimmen-Band (A16) */
function initBand(band) {
  const list = band.querySelector('.vgp-quotes');
  const toggle = band.querySelector('[data-vgp-qband-toggle]');
  if (!list) return;
  const items = [...list.children];
  // Unter zwei Stimmen gibt es keine Schleife: Band steht still, sonst rutscht die einzelne Karte und springt zurück.
  if (items.length < 2) { if (toggle) toggle.hidden = true; band.setAttribute('data-static', ''); return; }
  // Für die nahtlose Schleife die Stimmen einmal kopieren; Kopien sind für Screenreader und Tastatur unsichtbar.
  items.forEach((li) => {
    const c = li.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('a, button').forEach((x) => x.setAttribute('tabindex', '-1'));
    list.appendChild(c);
  });
  // langsam: rund 16 Sekunden je Stimme
  band.style.setProperty('--vgp-band-dur', `${items.length * 16}s`);
  toggle && toggle.addEventListener('click', () => {
    const paused = band.toggleAttribute('data-paused');
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggle.textContent = paused ? 'Weiterlaufen' : 'Anhalten';
  });
}

/* ---------------------------------------------------------------- Bewertungen */
function initReviews(sec) {
  const filter = sec.querySelector('[data-vgp-filter]');
  const cards = [...sec.querySelectorAll('.vgp-rcard')];
  const more = sec.querySelector('[data-vgp-more]');
  const status = sec.querySelector('[data-vgp-filter-status]');
  let expanded = false;
  let topic = '';
  function apply() {
    let n = 0;
    cards.forEach((c) => {
      const match = !topic || ` ${c.dataset.topics} `.includes(` ${topic} `);
      const visible = match && (topic || expanded || !c.hasAttribute('data-more'));
      c.hidden = !visible;
      if (visible) n++;
    });
    if (more) more.hidden = !!topic || expanded;
    if (status) status.textContent = `${n} Bewertungen angezeigt`;
  }
  filter && filter.addEventListener('click', (e) => {
    const b = e.target.closest('[data-topic]');
    if (!b) return;
    topic = b.dataset.topic;
    filter.querySelectorAll('[data-topic]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    apply();
  });
  more && more.addEventListener('click', () => { expanded = true; more.setAttribute('aria-expanded', 'true'); apply(); });
}

/* ---------------------------------------------------------------- Quellen-Info */
function initTips() {
  const close = (btn) => { btn.setAttribute('aria-expanded', 'false'); const p = document.getElementById(btn.getAttribute('aria-controls')); if (p) p.hidden = true; };
  document.querySelectorAll('[data-vgp-tip]').forEach((btn) => {
    const pop = document.getElementById(btn.getAttribute('aria-controls'));
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (pop) pop.hidden = !open;
    });
    btn.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(btn); });
  });
  document.addEventListener('click', () => document.querySelectorAll('[data-vgp-tip][aria-expanded="true"]').forEach(close));
}

let started = false;
function init() {
  if (started) return;
  started = true;
  const bar = document.querySelector('[data-vgp-sticky]');
  if (bar) initSticky(bar);
  document.querySelectorAll('[data-vgp-buyrow]').forEach(initBuyrow);
  document.querySelectorAll('[data-vgp-qband]').forEach(initBand);
  // Staffel zuletzt: ihr erstes vgp:selection erreicht so schon Leiste und Kaufzeile.
  document.querySelectorAll('[data-vgp-staffel]').forEach(initStaffel);
  document.querySelectorAll('.vgp-rev').forEach(initReviews);
  initTips();
}

if (customElements.get('product-form-component')) init();
else customElements.whenDefined('product-form-component').then(init);
setTimeout(init, 4000);
